export default {
    intro: 'Invite people to trend evaluations via a link. Participants do not need access to the Trendmanager. The voting takes place completely anonymously. No conclusions are possible as to which participants have started the evaluation completely, incompletely or not at all.',
    publicEvaluationLink: {
        label: 'Link',
        success: 'Link copied',
        tooltip: 'Copy link to clipboard',
        tooltipDisabled: 'Evaluation is inactive'
    },
    empty: 'Activate the rating via link to let people participate in the trend rating who do not have trend manager access.'
}
